import { useQuery } from '@tanstack/react-query';

import fetchHelpCenter from '../../services/helpCenter';
import OstroIcon from '../../assets/icons/ostro-icon.svg';
import {
  BackgroundStyleType,
  ButtonStyleType,
  ChatCustomization,
  GradientDirectionType,
  PlacementType,
} from '../../copied/types/ChatItems';

export const DefaultDesktopPlacement = {
  active: PlacementType.RIGHT,
  bottom: 30,
  left: 0,
  right: 20,
};

export const DefaultMobilePlacement = {
  active: PlacementType.RIGHT,
  bottom: 30,
  left: 20,
  right: 20,
};

export const defaultCustomization: ChatCustomization = {
  custom_css: '',
  bot_avatar: '',
  front_name: 'Inter',
  customer_logo_redirect_link: '',
  customer_logo_url: '',
  contact_forms_header_background_color: undefined,
  contact_forms_header_page_template: undefined,
  contact_forms_header_radius: 16,
  is_open_button_background: true,
  is_open_button_icon: true,
  is_open_button_shadow: true,
  main_color: '#FFFFFF',
  panel_color_top: '#FFFFFF',
  panel_color_bottom: '#FFFFFF',
  panel_close_button_background_color: '#FFFFFF',
  panel_close_button_X_color: '#000000',
  on_chat_buttons_radius: 0,
  open_bubble_background_color: '#FFFFFF',
  open_bubble_background_type: BackgroundStyleType.COLOR,
  open_bubble_gradient_end: '#FFFFFF',
  open_bubble_gradient_start: '#FFFFFF',
  open_bubble_gradient_type: GradientDirectionType.TOP_BOTTOM,
  open_button_background_color: '#FFFFFF',
  open_button_font_character: 0,
  open_button_font_line: 15,
  open_button_font_size: 12,
  open_button_icon: OstroIcon,
  open_button_radius: 62,
  open_button_shadow: '0px 2px 8px rgba(0, 0, 0, 0.15);',
  open_button_text_color: '#09305C',
  secondary_color: '#FFFFFF',
  desktop_position: DefaultDesktopPlacement,
  mobile_position: DefaultMobilePlacement,
  icon_text_padding: 4,
  is_open_button_border: false,
  left_side_padding: 8,
  // open_button_background_type: 'color',
  open_button_border_color: '#FFFFFF',
  open_button_border_width: 0,
  open_button_gradient_end: '#FFFFFF',
  open_button_gradient_start: '#FFFFFF',
  //open_button_gradient_type: GradientDirection.LEFT_RIGHT,
  open_button_icon_height: 36,
  // open_button_icon_position: 'left',
  open_button_icon_width: 36,
  open_button_action_icon: '',
  open_button_action_icon_width: 36,
  open_button_action_icon_height: 36,
  open_button_style: ButtonStyleType.CLASSIC,
  open_button_text: 'Chat with \n a nurse navigator',
  open_button_messages: [{ text: 'Chat with \n a nurse navigator' }],
  open_button_text_alignment: 'left',
  padding: 0,
  right_side_padding: 16,
  top_bottom_padding: 10,
  tailor_landing_border_radius: 0,
  fonts: [],

  // custom buttons
  faq_primary_button_radius: 0,
  is_faq_primary_button_background: true,
  faq_primary_button_background_type: BackgroundStyleType.COLOR,
  faq_primary_button_gradient_type: GradientDirectionType.LEFT_RIGHT,
  faq_primary_button_background_color: '#FFFFFF',
  faq_primary_button_gradient_start: null,
  faq_primary_button_gradient_end: null,
  is_faq_primary_button_shadow: false,
  faq_primary_button_shadow: '0px 2px 4px #000000',
  is_faq_primary_button_border: false,
  faq_primary_button_border_color: null,
  faq_primary_button_border_width: null,
  // Font/Text related
  faq_primary_button_font_size: 15,
  faq_primary_button_font_character: 0,
  faq_primary_button_font_line: 20,
  faq_primary_button_text_color: '#000000',
  faq_primary_button_text_alignment: 'right',
  // Icon related
  faq_primary_button_icon_height: 36,
  faq_primary_button_icon_width: 36,
  faq_primary_button_icon_position: 'left',
  // Padding related
  faq_primary_button_padding: 8,
  faq_primary_button_icon_text_padding: 8,
  faq_primary_button_right_side_padding: 6,
  faq_primary_button_left_side_padding: 16,
  faq_primary_button_top_bottom_padding: 6,
  // FAQ Secondary Button
  // FAQ Button styling and color
  faq_secondary_button_radius: 0,
  is_faq_secondary_button_background: true,
  faq_secondary_button_background_type: BackgroundStyleType.COLOR,
  faq_secondary_button_gradient_type: GradientDirectionType.LEFT_RIGHT,
  faq_secondary_button_background_color: '#FFFFFF',
  faq_secondary_button_gradient_start: null,
  faq_secondary_button_gradient_end: null,
  is_faq_secondary_button_shadow: false,
  faq_secondary_button_shadow: '0px 2px 4px #000000',
  is_faq_secondary_button_border: false,
  faq_secondary_button_border_color: null,
  faq_secondary_button_border_width: null,
  // Font/Text related
  faq_secondary_button_font_size: 15,
  faq_secondary_button_font_character: 0,
  faq_secondary_button_font_line: 20,
  faq_secondary_button_text_color: '#000000',
  faq_secondary_button_text_alignment: 'right',
  // Icon related
  faq_secondary_button_icon_height: 36,
  faq_secondary_button_icon_width: 36,
  faq_secondary_button_icon_position: 'left',
  // Padding related
  faq_secondary_button_padding: 8,
  faq_secondary_button_icon_text_padding: 8,
  faq_secondary_button_right_side_padding: 6,
  faq_secondary_button_left_side_padding: 16,
  faq_secondary_button_top_bottom_padding: 6,

  // FAQ Disabled Button styling and color
  faq_disabled_button_radius: 0,
  is_faq_disabled_button_background: true,
  faq_disabled_button_background_type: BackgroundStyleType.COLOR,
  faq_disabled_button_gradient_type: GradientDirectionType.LEFT_RIGHT,
  faq_disabled_button_background_color: '#FFFFFF',
  faq_disabled_button_gradient_start: null,
  faq_disabled_button_gradient_end: null,
  is_faq_disabled_button_shadow: false,
  faq_disabled_button_shadow: '0px 2px 4px #000000',
  is_faq_disabled_button_border: false,
  faq_disabled_button_border_color: null,
  faq_disabled_button_border_width: null,
  // Font/Text related
  faq_disabled_button_font_size: 15,
  faq_disabled_button_font_character: 0,
  faq_disabled_button_font_line: 20,
  faq_disabled_button_text_color: '#000000',
  faq_disabled_button_text_alignment: 'right',
  // Icon related
  faq_disabled_button_icon_height: 36,
  faq_disabled_button_icon_width: 36,
  faq_disabled_button_icon_position: 'left',
  // Padding related
  faq_disabled_button_padding: 8,
  faq_disabled_button_icon_text_padding: 8,
  faq_disabled_button_right_side_padding: 6,
  faq_disabled_button_left_side_padding: 16,
  faq_disabled_button_top_bottom_padding: 6,

  // Close button
  close_button_icon: '',
  close_button_icon_height: 24,
  close_button_icon_width: 24,
  close_button_background_color: '#FFFFFF',

  fe_config: {
    typography: {
      sectionHeader: {
        color: '#1E1E1E',
        fontSize: 14,
      },
    },
  },
};

export default function useFetchHelpCenter() {
  const { data, ...rest } = useQuery({
    queryKey: ['helpCenter'],
    queryFn: fetchHelpCenter,
  });

  if (data) {
    return {
      data: {
        ...data,
        customization: {
          ...defaultCustomization,
          ...data.customization,
          fe_config: {
            ...defaultCustomization.fe_config,
            ...data.customization.fe_config,
          },
        },
      },
      ...rest,
    };
  }

  return {
    data,
    ...rest,
  };
}
